export default "__VITE_ASSET__959d877a__"